<template>
    <div class="elec_battery_manage">
        <div class="chunenggui chunenggui1" @click="changeChuneng(1)">
            <img v-if="type == 1" src="../../../assets/image/custom/chunenggui_s.png" />
            <img v-else src="../../../assets/image/custom/chunenggui_us.png" />
            <div :class="[type==1 ? 'chunenggui_name chunenggui_name_s' : 'chunenggui_name chunenggui_name_us']">{{leftData && leftData.length>=1 ? leftData[0].point_name : ''}}</div>
        </div>
        <div class="chunenggui chunenggui2" @click="changeChuneng(2)">
            <img v-if="type == 2" src="../../../assets/image/custom/chunenggui_s.png" />
            <img v-else src="../../../assets/image/custom/chunenggui_us.png" />
            <div :class="[type==2 ? 'chunenggui_name chunenggui_name_s' : 'chunenggui_name chunenggui_name_us']">{{leftData && leftData.length>=2 ? leftData[1].point_name : ''}}</div>
        </div>
        <div class="elec_battery_right">
            <div class="battery_right_cnt">
                <div class="elec_title">PCS</div>
                <div class="battery_right_btn">
                  <!--  <div v-for="item in nbqList" :key="item.point_id" :class="[pscItem.point_id == item.point_id ? 'change_item change_item_s' : 'change_item change_item_us']" @click="changePSC(item)">
                        {{item.point_name}}
                    </div>-->
                </div>
                <div class="bottom_cnt">
                    <div class="right_inner_title">
                        <img src="../../../assets/image/custom/battery_elec_icon.png" style="width: 2rem;height: 2rem;"/>
                        <div class="right_title_name">
                            <div class="right_title_name_left">{{pscItem.point_name}}</div>
                        </div>
                    </div>
                    <el-scrollbar style="height: calc(100% - 2rem); ">
                        <div class="four_table">
                            <div class="four_table_inner" v-for="(item, index) in pscList" :key="index">
                                <div class="left">{{item.name}}</div>
                                <div class="right">{{item.data}}&nbsp;{{item.unit}}</div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
            <div class="battery_right_cnt">
                <div class="elec_title">电池簇</div>
                <div class="bottom_cnt">
                    <el-carousel :autoplay="false" arrow="never">
                        <el-carousel-item v-for="(item, index) in batteryNameList" :key="item">
                            <div class="right_inner_title">
                                <img src="../../../assets/image/custom/battery_dianchi_icon.png" style="width: 2rem;height: 2rem;"/>
                                <div class="right_title_name">
                                    <div class="right_title_name_left">{{item.point_name}}</div>
                                </div>
                            </div>
                            <el-scrollbar style="height: calc(90% - 2rem)">
                                <div class="four_table">
                                    <div class="four_table_inner" v-for="(data, index2) in batteryList[index]" :key="index">
                                        <div class="left">{{data.name}}</div>
                                        <div class="right">{{data.data}}&nbsp;{{data.unit}}</div>
                                    </div>
                                </div>
                            </el-scrollbar>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";

import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import * as api from "@/http/api.js";
import { getDataAll } from "@/http/http-60.js";
export default {
    data() {
        return {
            pscItem: '',
            pscList: [],
            batteryNameList: [],
            type: 1,
            leftData: [],
            nbqList: [],
            batteryList: [],
            loading: null,
            timer: null,
            point_ids: [],
        };
    },
    async mounted() {
        await this.getPointListByPointClassId();
        this.setTimer();
    },
    computed: {
        language() {
            return this.$store.state.language.language;
        },
        pcsData() {
            return [
                {
                    key: 'pcs_uab',
                    name: this.$t('storageMonitor.pcs_uab'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'pcs_ubc',
                    name: this.$t('storageMonitor.pcs_ubc'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'pcs_uca',
                    name: this.$t('storageMonitor.pcs_uca'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'pcs_ia',
                    name: this.$t('storageMonitor.pcs_ia'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'pcs_ib',
                    name: this.$t('storageMonitor.pcs_ib'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'pcs_ic',
                    name: this.$t('storageMonitor.pcs_ic'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'pcs_lwpl',
                    name: this.$t('storageMonitor.pcs_lwpl'),
                    data: '',
                    unit: 'Hz'
                },
                {
                    key: 'pcs_pl',
                    name: this.$t('storageMonitor.pcs_pl'),
                    data: '',
                    unit: 'Hz'
                },
                {
                    key: 'pcs_jlldl',
                    name: this.$t('storageMonitor.pcs_jlldl'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'pcs_zldy',
                    name: this.$t('storageMonitor.pcs_zldy'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'pcs_zldl',
                    name: this.$t('storageMonitor.pcs_zldl'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'pcs_zzlgl',
                    name: this.$t('storageMonitor.pcs_zzlgl'),
                    data: '',
                    unit: 'kW'
                },
                {
                    key: 'pcs_scszgl',
                    name: this.$t('storageMonitor.pcs_scszgl'),
                    data: '',
                    unit: 'kW'
                },
                {
                    key: 'pcs_p',
                    name: this.$t('storageMonitor.pcs_p'),
                    data: '',
                    unit: 'kW'
                },
                {
                    key: 'pcs_q',
                    name: this.$t('storageMonitor.pcs_q'),
                    data: '',
                    unit: 'kW'
                },
                {
                    key: 'pcs_yxzt',
                    name: this.$t('storageMonitor.pcs_yxzt'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'pcs_zcdl',
                    name: this.$t('storageMonitor.pcs_zcdl'),
                    data: '',
                    unit: 'kW.h'
                },
                {
                    key: 'pcs_zfdl',
                    name: this.$t('storageMonitor.pcs_zfdl'),
                    data: '',
                    unit: 'kW.h'
                },
                {
                    key: 'pcs_rcdl',
                    name: this.$t('storageMonitor.pcs_rcdl'),
                    data: '',
                    unit: 'kW.h'
                },
                {
                    key: 'pcs_rfdl',
                    name: this.$t('storageMonitor.pcs_rfdl'),
                    data: '',
                    unit: 'kW.h'
                },
                {
                    key: 'pcs_glys',
                    name: this.$t('storageMonitor.pcs_glys'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'pcs_nbwd',
                    name: this.$t('storageMonitor.pcs_nbwd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'pcs_srqwd',
                    name: this.$t('storageMonitor.pcs_srqwd'),
                    data: '',
                    unit: '℃'
                }
            ]
        },
        batteryData() {
            return [
                {
                    key: 'bms_soc',
                    name: this.$t('storageMonitor.bms_soc'),
                    data: '',
                    unit: '%'
                },
                {
                    key: 'bms_soh',
                    name: this.$t('storageMonitor.bms_soh'),
                    data: '',
                    unit: '%'
                },
                {
                    key: 'bms_dccyxzt',
                    name: this.$t('storageMonitor.bms_dccyxzt'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_zt',
                    name: this.$t('storageMonitor.bms_zt'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_v',
                    name: this.$t('storageMonitor.bms_v'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'bms_i',
                    name: this.$t('storageMonitor.bms_i'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'bms_zgdtdy',
                    name: this.$t('storageMonitor.bms_zgdtdy'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'bms_zddtdy',
                    name: this.$t('storageMonitor.bms_zddtdy'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'bms_zgwd',
                    name: this.$t('storageMonitor.bms_zgwd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'bms_zdwd',
                    name: this.$t('storageMonitor.bms_zdwd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'bms_zgsoc',
                    name: this.$t('storageMonitor.bms_zgsoc'),
                    data: '',
                    unit: '%'
                },
                {
                    key: 'bms_zdsoc',
                    name: this.$t('storageMonitor.bms_zdsoc'),
                    data: '',
                    unit: '%'
                },
                {
                    key: 'bms_zgdtdybh',
                    name: this.$t('storageMonitor.bms_zgdtdybh'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_zddtdybh',
                    name: this.$t('storageMonitor.bms_zddtdybh'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_zgwdbh',
                    name: this.$t('storageMonitor.bms_zgwdbh'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_zdwdbh',
                    name: this.$t('storageMonitor.bms_zdwdbh'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_zdrxcddl',
                    name: this.$t('storageMonitor.bms_zdrxcddl'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'bms_zdrxfddl',
                    name: this.$t('storageMonitor.bms_zdrxfddl'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'bms_cndtdygs',
                    name: this.$t('storageMonitor.bms_cndtdygs'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_cndtwdgs',
                    name: this.$t('storageMonitor.bms_cndtwdgs'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_zddywd',
                    name: this.$t('storageMonitor.bms_zddywd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'bms_zxdywd',
                    name: this.$t('storageMonitor.bms_zxdywd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'bms_zdwddy',
                    name: this.$t('storageMonitor.bms_zdwddy'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'bms_zxwddy',
                    name: this.$t('storageMonitor.bms_zxwddy'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'bms_cddlfz',
                    name: this.$t('storageMonitor.bms_cddlfz'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'bms_fddlfz',
                    name: this.$t('storageMonitor.bms_fddlfz'),
                    data: '',
                    unit: 'A'
                }
            ]
        }
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                if(this.pscItem && this.pscItem.point_id) {
                    this.getPscList();
                    this.getBattery();
                }
            }, 60000);
        },
        async getPointListByPointClassId() {
            this.loading = this.$loading({
                lock: true,
                text: 'loading...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.chunenglist = [];
            await api.getPointListByPointClassId({point_class_id:'020'}).then(res => {
                if (res && res.error_code == 0) {
                    this.leftData = res.bus_json.filter(item => item.collector_id != null);
                    this.changeChuneng(1);
                }
            });
        },
        async getNbqList(point_id) {
            await api.getNbqList({point_id: point_id}).then(res => {
                if (res && res.error_code == 0) {
                    this.nbqList = res.bus_json.nbqList;
                    this.pscItem = this.nbqList && this.nbqList.length>0 ? this.nbqList[0] : '';
                    if(this.pscItem && this.pscItem.point_id) {
                        this.getPscList();
                        this.getBattery();
                    }
                }
            });
        },
        async getPscList() {
            await getDataAll([this.pscItem.point_id]).then(res => {
                let valueJson = res.bus_json;
                if(valueJson[this.pscItem.point_id]) {
                    const realData = valueJson[this.pscItem.point_id];
                    const temp = this.pcsData;
                    temp.forEach(item => {
                        if(item.key == 'pcs_yxzt') {
                            if(realData[item.key] == 0) item.data = this.$t('storageMonitor.pcs_yxzt0');
                            else if(realData[item.key] == 1) item.data = this.$t('storageMonitor.pcs_yxzt1');
                            else if(realData[item.key] == 2) item.data = this.$t('storageMonitor.pcs_yxzt2');
                            else if(realData[item.key] == 3) item.data = this.$t('storageMonitor.pcs_yxzt3');
                            else if(realData[item.key] == 4) item.data = this.$t('storageMonitor.pcs_yxzt4');
                            else if(realData[item.key] == 5) item.data = this.$t('storageMonitor.pcs_yxzt5');
                            else if(realData[item.key] == 6) item.data = this.$t('storageMonitor.pcs_yxzt6');
                        } else {
                            item.data = realData[item.key];
                        }
                    })
                    this.pscList = temp;
                }
            });
        },
        async getBattery() {
            await api.getNbqList({point_id: this.pscItem.point_id}).then(res => {
                if (res && res.error_code == 0) {
                    this.batteryNameList = res.bus_json.nbqList;
                    this.point_ids = [];
                    this.batteryNameList.forEach(item => {
                        this.point_ids.push(item.point_id)
                    })
                    this.getBatteryAll(this.point_ids)
                }
            });
        },
        async getBatteryAll(point_ids) {
            await getDataAll(point_ids).then(res => {
                let valueJson = res.bus_json;
                this.point_ids.forEach(point_id => {
                    const realData = valueJson[point_id];
                    let temp = this.batteryData;
                    temp.forEach(item => {
                        if(item.key == 'bms_dccyxzt') {
                            if(realData[item.key] == 0) item.data = this.$t('storageMonitor.battery_run_state0');
                            else if(realData[item.key] == 1) item.data = this.$t('storageMonitor.battery_run_state1');
                            else if(realData[item.key] == 2) item.data = this.$t('storageMonitor.battery_run_state2');
                            else if(realData[item.key] == 3) item.data = this.$t('storageMonitor.battery_run_state3');
                            else if(realData[item.key] == 4) item.data = this.$t('storageMonitor.battery_run_state4');
                        } else if(item.key == 'bms_zt') {
                            if(realData[item.key] == 1) item.data = this.$t('storageMonitor.bms_state1');
                            else if(realData[item.key] == 2) item.data = this.$t('storageMonitor.bms_state2');
                            else if(realData[item.key] == 3) item.data = this.$t('storageMonitor.bms_state3');
                            else if(realData[item.key] == 4) item.data = this.$t('storageMonitor.bms_state4');
                        } else {
                            item.data = realData[item.key];
                        }
                    })
                    this.batteryList.push(temp);
                })
            });
        },
        async changeChuneng(type) {
          //  if(!this.loading) 
                this.loading = this.$loading({
                    lock: true,
                    text: 'loading...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            this.type = type;
            if(type == 1 && this.leftData && this.leftData.length>=1) {
                const point_id = this.leftData[0].point_id;
                await this.getNbqList(point_id);
            }
            if(type == 2 && this.leftData && this.leftData.length>=2) {
                const point_id = this.leftData[1].point_id;
                await this.getNbqList(point_id);
            }
            if(this.loading) this.loading.close();
        },
        changePSC(item) {
            this.pscItem = item;
            if(this.pscItem && this.pscItem.point_id) this.getBattery();
        }
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.elec_battery_manage {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 2rem;
    //border: 1px solid red;
    background: url("../../../assets/image/custom/elec_battery_back.png") no-repeat left 100%;
    background-size: 60% auto;
    position: relative;
    .el-carousel {
        height: 100%;
        .el-carousel__container {
            height: 100%;
        }
        .el-carousel__arrow {
            width: 2rem;
            height: 2rem;
        }
    }
    .elec_battery_right {
       // border: 1px solid red;
        width: 56%;
        height: 100%;
        margin-left: 44%;
        box-sizing: border-box;
        .battery_right_cnt {
            width: 100%;
            height: 49%;
            margin-bottom: 1%;
            background: url("../../../assets/image/custom/dianchi_rect.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            .four_table {
                width: 90%;
                margin-left: 5%;
                height: 90%;
                display: inline-flex; 
                flex-flow: row wrap;
                .four_table_inner {
                    //border: 1px solid blue;
                    width: 25%;
                   // height: 2rem;
                    min-height: 2rem;
                    text-align: center;
                   // line-height: 2rem;
                    font-size: 0.9rem;
                    border-bottom: 1px dotted rgba(24, 47, 76, 1);
                    display: inline-flex;
                    align-items: center;
                    .left {
                        width: 65%;
                        color: rgba(204, 227, 255, 1);
                        text-align: left;
                        font-size: 0.75rem;
                    }
                    .right {
                        flex: 1;
                        color: rgba(255, 255, 255, 1);
                        text-align: left;
                        font-size: 0.75rem;
                    }
                    // &:nth-child(4n + 1) {
                    //     background-color: red;
                    // }
                    &:nth-child(2n + 1) {
                        color: rgba(148, 194, 232, 1);
                    }
                }
            }
            .elec_title {
                position: absolute;
                top: 2.6%;
                left: 8%;
                color: rgba(148, 194, 232, 1);
                font-size: 0.8rem;
            }
            .bottom_cnt {
               // border: 1px solid red;
                position: absolute;
                top: 15%;
                left: 2rem;
                width: calc(100% - 4rem);
                height: 80%;
                box-sizing: border-box;
                color: rgba(148, 194, 232, 1);
                font-size: 0.8rem;
                .right_inner_title {
                    width: 100%;
                    display: inline-flex;
                    align-items: center;
                }
                .right_title_name {
                    border-bottom: 1px solid rgba(19, 125, 254, 0.3);
                    width: calc(100% - 3rem);
                    margin-left: 1rem;
                    position: relative;
                    height: 1.4rem;
                    .right_title_name_left {
                        position: absolute;
                        top: 0;
                        left: 0;
                        height: 1.4rem;
                        line-height: 1.4rem;
                        width: 35%;
                        border-bottom: 2px solid rgba(19, 125, 254, 1);
                    }
                }
            }
            .battery_right_btn {
                position: absolute;
                top: 2%;
                right: 0;
                width: 80%;
               // margin-left: 20%;
                //height: 3rem;
               // border: 1px solid red;
                display: inline-flex;
                align-items: center;
                justify-content: flex-end;
                .change_item {
                    width: 3rem;
                    height: 1.2rem;
                    line-height: 1.2rem;
                    font-size: 0.7rem;
                    text-align: center;
                    cursor: pointer;
                }
                .change_item_s {
                    color: rgba(19, 125, 254, 1);
                    border: 1px solid rgba(19, 125, 254, 1);
                   // background-color: rgba(148, 194, 232, 1);
                    border-radius: 5px;
                }
                .change_item_us {
                    color: #F3F3F3;
                    border: none;//1px solid #F3F3F3;
                }
            }
        }
    }
    .chunenggui {
        cursor: pointer;
        display: inline-flex;
        flex-flow: column;
        img {
            width: 12rem;
        }
        .chunenggui_name {
            height: 3rem;
            line-height: 3rem;
            text-align: center;
            font-size: 0.9rem;
            color: #fff;
        }
        .chunenggui_name_s {
            background: url("../../../assets/image/custom/chunenggui_name_s.png") no-repeat;
        }
        .chunenggui_name_us {
            background: url("../../../assets/image/custom/chunenggui_name_us.png") no-repeat;
        }
    }
    .chunenggui1 {
        position: absolute;
        top: 68%;
        left: 3.5%;
    }
    .chunenggui2 {
        position: absolute;
        top: 68%;
        left: 30.2%;
    }
    .elec_battery_right {

    }
    .el-carousel__arrow {
        background-color: rgba(148, 194, 232, 1);
    }
    .el-carousel__arrow--left {
        left: 0;
    }
    .el-carousel__arrow--right {
        right: 0;
    }
}
</style>
